import styled from 'styled-components';

export const Styles = styled.div`
  border-spacing: 0;
  border: 1px solid #dddddd;
  margin-bottom: 5px;
  box-shadow: -2px 1px 2px 0px #d8d8d880;

  .react-table {
    min-height: 20rem;
    white-space: nowrap;
    font-size: 0.8rem;

    .tr-container {
      padding: 0;
      z-index: 0;

      & > .tr {
        .td {
          border-top: 1px solid #dddddd;
        }
      }
    }

    .th {
      /* center content vertical & horizontal */
      display: flex !important;
      justify-content: center;
      align-items: center;
      user-select: none;
      text-align: center;
      white-space: normal;
      background-color: #f8f8f8;
      /* make sure the filter inputs are not overflowing */
      > div {
        width: 100%;
        padding-left: 5px;
        padding-right: 5px;
        > input {
          max-width: 100%;
          border: none;
          border-bottom: solid 1px #aaa;
          border-radius: 0px;
        }
      }
      &.unclickable {
        cursor: default !important;
      }
    }

    .td {
      display: flex !important;
      align-items: center;
      font-variant-numeric: tabular-nums lining-nums;
      justify-content: flex-end;
      padding-top: 0;
      padding-bottom: 0;
      padding-left: 0.5rem;
      padding-right: 0.5rem;
      overflow-x: hidden;
      &.align-left {
        justify-content: flex-start;
      }
      &.align-center {
        justify-content: center;
      }
      &.fav-stock-floating-modal-general-cell {
        padding-top: 5px;
        align-items: flex-start;
        font-size: 14px;
      }
    }

    .th,
    .td {
      padding: 5px;
      background-color: #fff;
      overflow: hidden;

      > svg {
        height: 1.65rem;
      }
      & > div.resizer {
        display: inline-block;
        width: 10px;
        height: 100%;
        position: absolute;
        right: 0;
        top: 0;
        transform: translateX(50%);
        z-index: 1;

        &.is-resizing {
          background-color: #5d5d5d;
        }
      }
    }

    .th {
      border-right: 1px solid #dddddd;
      overflow-y: auto;
    }

    .td {
      border-right: 1px solid #dddddd;
      &::after {
        content: '';
        position: absolute;
        right: 0;
        top: 0;
        height: 100%;
        width: 100%;
        pointer-events: none;
        background: none;
      }
    }

    &.sticky {
      overflow: scroll;

      .header,
      .footer {
        z-index: 1;
        padding: 0;
      }

      .body {
        position: relative;
        z-index: 0;
      }

      [data-sticky-td] {
        position: sticky;
        box-shadow: rgba(0, 0, 0, 0.24) 0px 3px 8px;
      }

      [data-sticky-last-left-td] {
        box-shadow: 1px 0px 0px #ccc;
      }

      [data-sticky-first-right-td] {
        box-shadow: -1px 0px 0px #ccc;
      }
    }

    .dl-switch-container {
      padding-bottom: 0;
      padding-top: 0;
      padding-bottom: 5px;
      font-size: 0.7rem;
      white-space: normal;
    }
  }
`;
